import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { useIsMobile } from '../../hooks/useResponsive';

/**
 * Responsive Dialog wrapper that automatically applies fullScreen on mobile
 * @param {Object} props - All standard MUI Dialog props
 */
const ResponsiveDialog = ({ children, fullScreen: fullScreenProp, ...props }) => {
  const isMobile = useIsMobile();

  // Use fullScreen prop if explicitly provided, otherwise auto-apply on mobile
  const fullScreen = fullScreenProp !== undefined ? fullScreenProp : isMobile;

  return (
    <Dialog fullScreen={fullScreen} {...props}>
      {children}
    </Dialog>
  );
};

ResponsiveDialog.propTypes = {
  children: PropTypes.node.isRequired,
  fullScreen: PropTypes.bool,
};

export default ResponsiveDialog;
